<div class="login-container">
  <h2>{{ 'LOGIN.RESET_PASSWORD_TITLE' | translate }}</h2>

  <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
    <nz-form-item nzAlign="top">
      <nz-form-label nzFor="newPassword">{{ 'LOGIN.NEW_PASSWORD' | translate }}</nz-form-label>
      <nz-form-control>
        <div class="input-container">
          <input
            nz-input
            [type]="passwordVisible ? 'text' : 'password'"
            formControlName="newPassword"
            placeholder="{{ 'LOGIN.NEW_PASSWORD_PLACEHOLDER' | translate }}" />
          <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'" (click)="togglePasswordVisibility()"></i>
          <div class="password-strength-meter" *ngIf="resetPasswordForm.get('newPassword')?.value">
            <div class="strength-bar" [ngClass]="passwordStrength"></div>
            <div class="strength-label" [ngClass]="passwordStrength">
              {{ 'SIGNUP.STRENGTH_' + passwordStrength.toUpperCase() | translate }}
            </div>
          </div>
          <div
            *ngIf="resetPasswordForm.get('newPassword')?.invalid && resetPasswordForm.get('newPassword')?.dirty"
            class="error-text"
            [ngClass]="passwordStrength || 'weak'"
          >
            <ul>
              <li *ngIf="resetPasswordForm.get('newPassword')?.errors?.['required']">{{ 'SIGNUP.PASSWORD_REQUIRED' | translate }}</li>
              <li *ngIf="resetPasswordForm.get('newPassword')?.errors?.['minlength']">{{ 'SIGNUP.PASSWORD_MIN_LENGTH' | translate }}</li>
              <li *ngIf="resetPasswordForm.get('newPassword')?.errors?.['passwordStrength']">{{ 'SIGNUP.PASSWORD_COMPLEXITY' | translate }}</li>
              <li *ngIf="resetPasswordForm.get('newPassword')?.errors?.['passwordTooLong']">{{ 'SIGNUP.PASSWORD_TOO_LONG' | translate }}</li>
            </ul>
          </div>
        </div>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item nzAlign="top">
      <nz-form-label nzFor="confirmPassword">{{ 'LOGIN.CONFIRM_PASSWORD' | translate }}</nz-form-label>
      <nz-form-control>
        <input nz-input type="password" formControlName="confirmPassword" placeholder="{{ 'LOGIN.CONFIRM_PASSWORD_PLACEHOLDER' | translate }}" />
      </nz-form-control>
    </nz-form-item>
    <div class="login-actions">
      <button nz-button nzType="primary" type="submit">{{ 'LOGIN.SUBMIT' | translate }}</button>
    </div>
  </form>
</div>
